export default "__VITE_ASSET__2e6c4953__"